import React from 'react'

export default function errorpage() {
  return (
    <>
   

<div    className="error" id="error">
            <div    className="container">
                <div    className="content centered"
                style={{display:"flex",alignItems:"center",flexDirection:"column",marginTop:"7rem"}}
                ><img style={{width:"500px"}} src="http://127.0.0.1:5500/codeskdhaka.com/html/eduman-prv/eduman/assets/img/bg/error-thumb.png"/>
                    <h1>Oops, looks like the page is lost.</h1>
                    <p style={{fontSize:"22px"}}    className="sub-header text-block-narrow">This is not a fault, just an accident that was not intentional.</p>
                </div>
        </div>
        </div>
      
    </>
  )
}
